import { useEffect, useState } from "react";
import { Smartphone } from "lucide-react";

const standalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent || "");

// Botón "Instalar app": Android/computadora con el aviso del navegador; iPhone con la indicación de Safari.
export default function InstallApp({ collapsed }) {
  const [prompt, setPrompt] = useState(() => window.__afmInstallPrompt || null);
  const [help, setHelp] = useState(false);
  const [done, setDone] = useState(standalone());

  useEffect(() => {
    const ready = () => setPrompt(window.__afmInstallPrompt || null);
    const installed = () => { setDone(true); setPrompt(null); };
    window.addEventListener("afm-install-ready", ready);
    window.addEventListener("appinstalled", installed);
    return () => { window.removeEventListener("afm-install-ready", ready); window.removeEventListener("appinstalled", installed); };
  }, []);

  if (done || (!prompt && !isIOS())) return null;
  const click = async () => {
    if (!prompt) { setHelp((h) => !h); return; }
    prompt.prompt();
    try { const r = await prompt.userChoice; if (r?.outcome === "accepted") setDone(true); } catch { /* noop */ }
    window.__afmInstallPrompt = null;
    setPrompt(null);
  };
  return (
    <div className={collapsed ? "px-2 pb-2" : "px-3 pb-2"}>
      <button type="button" onClick={click} data-testid="install-app" title="Instalar la app"
        className={`flex w-full items-center gap-3 rounded-xl border border-white/10 bg-white/[0.04] px-3 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-white/[0.08] ${collapsed ? "justify-center" : ""}`}>
        <Smartphone className="h-[18px] w-[18px] shrink-0" strokeWidth={1.5} />
        {!collapsed && <span>Instalar la app</span>}
      </button>
      {help && !collapsed && (
        <p className="mt-2 rounded-lg bg-white/[0.06] px-3 py-2 text-[11px] leading-relaxed text-[#D1D5DB]">
          En Safari toca <strong>Compartir</strong> (el cuadro con la flecha) y luego <strong>Agregar a inicio</strong>.
        </p>
      )}
    </div>
  );
}
